import React from "react"

const SalesIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="18" viewBox="0 0 22 18" fill="none">
            <path d="M10 17H9.5C5.74142 17 3.86213 17 2.60746 16.0091C2.40678 15.8506 2.22119 15.676 2.0528 15.4871C1 14.3062 1 12.5375 1 9C1 5.46252 1 3.69377 2.0528 2.5129C2.22119 2.32403 2.40678 2.14935 2.60746 1.99087C3.86213 1 5.74142 1 9.5 1H12.5C16.2586 1 18.1379 1 19.3925 1.99087C19.5932 2.14935 19.7788 2.32403 19.9472 2.5129C20.8957 3.57684 20.9897 5.11799 20.999 8" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M1 6H21" stroke="#21A6AA" stroke-width="1.5" stroke-linejoin="round" />
            <path d="M13 15C13 15 14 15 15 17C15 17 18.1765 12 21 11" stroke="#21A6AA" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default SalesIcon



